// extracted by mini-css-extract-plugin
export default {"previewCard":"styles_previewCard__Bl60j"};